module.exports = __webpack_public_path__ + "static/media/upp_flo_wor_foo.1cbb34aa.png";